
export const pdfRegexTest = ($http: HttpApi) => ({
  create: (data: HttpParams['body'] = {}) => $http.$post('/builder/tools/pdf_regex_test', { body: data }),
});
